import React from 'react';
import { useSelector } from 'react-redux';
import {
  Container, Card, CardBody, Row, Col,
} from 'reactstrap';

import InvestorDashboard from '../../Investor/InvestorDashboard';
import { Helmet } from 'react-helmet';

const ManagedInvestorDashboard = () => {
  const currentManagedUser = useSelector((state) => state.currentManagedUser);
  return (
    <>
      <Helmet>
        <title>Authorized Account Dashboard - Alumni Ventures</title>
        <link rel="shortcut icon" href={`${process.env.AVG_API_PATH}/favicon.ico`} sizes="16x16" />
      </Helmet>
      {!currentManagedUser && (
        <Container className="dashboard" style={{ paddingTop: '30px' }}>
          <Card className="pb-0" style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
            <CardBody
              style={{
                padding: '8px, 10px',
              }}
              className="py-3"
            >
              <Row>
                <Col>
                  <h3>Select a User From the Dropdown Above</h3>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      )}
      {currentManagedUser && (
        <div style={{ paddingTop: '30px' }}>
          <InvestorDashboard />
        </div>
      )}
    </>
  );
};

export default ManagedInvestorDashboard;